import { useEffect } from 'react';
import { BOOT_UNREACHABLE_REPORT_MS } from '~/boot-timeouts';
import { useIoContext, useStore } from '~/contexts';
import { useNetworkRetry } from '~/hooks/networkRetry/useNetworkRetry';
import { useSetAuthToken } from '~/hooks/useSetAuthToken';
import { selectors } from '~/store/state-selectors';
export class BootUnreachableError extends Error {
    constructor(){
        super('Boot unreachable: the network failure screen is still showing after the report delay');
    }
}
export function useBootNetworkRetry(schedule) {
    const bootFailedOnNetwork = useStore(selectors.isBootNetworkFailure);
    const setAuthToken = useSetAuthToken();
    const { cookies, browser } = useIoContext();
    useEffect(()=>{
        if (bootFailedOnNetwork) {
            return browser.schedule(BOOT_UNREACHABLE_REPORT_MS, ()=>browser.reportError(new BootUnreachableError()));
        }
    }, [
        bootFailedOnNetwork
    ]);
    return useNetworkRetry({
        active: bootFailedOnNetwork,
        attempt: ()=>setAuthToken(cookies.getAuthToken()),
        schedule
    });
}
